import Link from "next/link";
import { useState, useRef, useEffect } from "react";

const LoginDropdown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const desktopDropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideDesktop =
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target);
      const isOutsideMobile =
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target);

      if (isOutsideDesktop && isOutsideMobile) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLoginClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const handleMouseEnter = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setDropdownOpen(false);
    }, 200);
  };

  const handleDropdownItemClick = (e) => {
    e.stopPropagation();
    setDropdownOpen(false);
  };

  const handleDropdownClick = (e) => {
    e.stopPropagation();
  };

  const renderDropdownContent = () => (
    <div className="rbt-user-menu-list-wrapper" onClick={handleDropdownClick}>
      <div className="inner">
        <ul className="user-list-wrapper">
          <li>
            <Link href="/login" onClick={handleDropdownItemClick}>
              <i className="feather-user"></i>
              <span>Student Login</span>
            </Link>
          </li>
          <li>
            <Link
              href="/login?role=instructor"
              onClick={handleDropdownItemClick}
            >
              <i className="feather-book-open"></i>
              <span>Instructor Login</span>
            </Link>
          </li>
          <li>
            <Link href="/login?role=hr" onClick={handleDropdownItemClick}>
              <i className="feather-briefcase"></i>
              <span>HR Login</span>
            </Link>
          </li>
          <li>
            <Link href="/login?role=admin" onClick={handleDropdownItemClick}>
              <i className="feather-briefcase"></i>
              <span>Admin Login</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <>
      <li
        className="account-access rbt-user-wrapper d-none d-xl-block"
        ref={desktopDropdownRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Link href="#" onClick={handleLoginClick}>
          <i className="feather-user"></i>&nbsp;<span>Login</span>
          <i className={`feather-chevron-${dropdownOpen ? 'up' : 'down'}`} style={{ marginLeft: '4px', fontSize: '14px' }}></i>
        </Link>
        {dropdownOpen && renderDropdownContent()}
      </li>

      <li
        className="access-icon rbt-user-wrapper d-block d-xl-none"
        ref={mobileDropdownRef}
      >
        <Link className="rbt-round-btn" href="#" onClick={handleLoginClick}>
          <i className="feather-user"></i>
        </Link>
        {dropdownOpen && renderDropdownContent()}
      </li>
    </>
  );
};

export default LoginDropdown;
